import { render, staticRenderFns } from "./AddNewPayee.vue?vue&type=template&id=566b906d&scoped=true"
import script from "./AddNewPayee.vue?vue&type=script&lang=js"
export * from "./AddNewPayee.vue?vue&type=script&lang=js"
import style0 from "./AddNewPayee.vue?vue&type=style&index=0&id=566b906d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566b906d",
  null
  
)

export default component.exports